import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { TokenStorageService } from '../services/token-storage.service';

/**
 * Guards routes that only make sense for orgs billed directly (balance, payment
 * history). Orgs served by a reseller/partner get the shared 401 page, so typing
 * the URL by hand cannot reach the screen or fire its requests.
 */
export const noPartnerGuard: CanActivateFn = () => {
  const store = inject(TokenStorageService);
  const router = inject(Router);
  if (store.hasPartner$()) {
    // redirect inside this navigation instead of starting a second one, so the
    // browser's back button doesn't land on the entry we would have pushed
    return router.createUrlTree(['/user-main/401']);
  }
  return true;
};
